import Header from '../components/Header';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import ProductShowcase from '../components/ProductShowcase';
import FinalCta from '../components/FinalCta';
import Footer from '../components/Footer';
import useDocumentMeta from '../hooks/useDocumentMeta';

export default function LandingPage() {
  useDocumentMeta({
    title: 'ShareShutter: Collect Every Moment',
    description:
      "Create a shared event collection, invite guests with a QR code or link, and collect everyone's photos and videos in one place.",
    canonicalPath: '/',
  });

  return (
    <>
      <Header />
      <main className="page">
        <Hero />
        <HowItWorks />
        <ProductShowcase />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}
